import { useQuoteBuilderActions } from '@paradigm/features/src/unified-rfqs/ui/drfq/quote-builder/form-context';
import { useQuoteBuilderView } from '@paradigm/features/src/unified-rfqs/ui/drfq/quote-builder/view';

import BaseAccountSelect from '#/components/account-selection/AccountSelect';
import { useDrfqRfq } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';
import useAccountsWithDefault from '@paradigm/features/src/preferences/default-accounts/useAccountsWithDefault';
import { findBaseProductCode } from '@paradigm/features/src/products/domain';

function AccountSelect() {
  const { account } = useQuoteBuilderView();
  const { changeAccount } = useQuoteBuilderActions();
  const { venue, product_codes } = useDrfqRfq();
  const productCode = findBaseProductCode(product_codes);
  const cachedAccounts = useAccountsWithDefault(venue, productCode);

  return (
    <BaseAccountSelect
      value={account}
      venue={venue}
      productCode={productCode}
      onChange={changeAccount}
      cachedAccounts={cachedAccounts}
    />
  );
}

export default AccountSelect;
